/*
 * @Author: bianbinbin
 * @Date: 2024-03-06 18:57:36
 * @LastEditors: bianbinbin
 * @LastEditTime: 2024-08-12 09:31:45
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/weatherQuery.js
 */
const weatherQuery = r => require.ensure([], () => r(require('@/views/weatherQuery/weatherQuery.vue'), 'weatherQuery'))
const weatherWarn = r => require.ensure([], () => r(require('@/views/weatherWarn/weatherWarn.vue'), 'weatherWarn'))
const weatherAffect = r => require.ensure([], () => r(require('@/views/meteoroGram/weatherAffect.vue'), 'weatherAffect'))
const weatherDetail = r => require.ensure([], () => r(require('@/views/meteoroGram/weatherDetail.vue'), 'weatherDetail'))
const router = [
  {
    path: '/weatherQuery',
    name: 'weatherQuery',
    meta: {
      title: '气象查询'
    },
    component: weatherQuery
  },
  {
    path: '/weatherWarn',
    name: 'weatherWarn',
    meta: {
      title: '气象查询'
    },
    component: weatherWarn
  },
  {
    path: '/weatherDetail',
    name: 'weatherDetail',
    meta: {
      title: '气象查询'
    },
    component: weatherDetail
  },
  {
    path: '/meteoroGram',
    name: 'meteoroGram',
    meta: {
      title: '气象图'
    },
    component: weatherAffect
  }
]

export default router
